import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import PublicLibraryHomeView from "./containers/library-home/PublicLibraryHomeView";
import PublicWorkshopsView from "./containers/workshops/PublicWorkshopsView";
import { Redirect, Route, Switch } from "react-router-dom";
import SubMenu from "../components/submenu-workshops-view";
import SubMenuPublicWorkshops from "../components/submenu-workshops-view/containers/SubMenuPublicWorkshops";

export enum DashboardPublicLibraryViewPages {
  PUBLIC_HOME = "/publiclibrary/libraryhome",
  PUBLIC_WORKSHOPS = "/publiclibrary/workshops",
}

const PublicLibraryView = () => {
  return (
    <div className="public-library-view-wrapper">
      <SubMenu>
        <SubMenuPublicWorkshops />
      </SubMenu>
      <Container fluid className="pt-0">
        <Row>
          <Col md={12} lg={12} sm={12} style={{ paddingLeft: "300px" }}>
            <Switch>
              <Route path={DashboardPublicLibraryViewPages.PUBLIC_HOME} exact>
                <PublicLibraryHomeView />
              </Route>
              <Route path={DashboardPublicLibraryViewPages.PUBLIC_WORKSHOPS}>
                <PublicWorkshopsView />
              </Route>
              <Route path={"/publiclibrary"}>
                <Redirect to={DashboardPublicLibraryViewPages.PUBLIC_HOME} />
              </Route>
            </Switch>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PublicLibraryView;
